<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div>
    <!-- <h3 class="text-primary mb-4 mr-3 font-30px">
      {{ $t("calcul_formulas") }}
    </h3> -->
    <div class="giga-fields">
      <div
        :class="[
          condition.emmy.value.$anyDirty && condition.emmy.value.$invalid
            ? 'field-hasError'
            : '',
          !condition.emmy.value.required ? 'field-isRequired' : ''
        ]"
        class="giga-input_field col-lg-12"
        v-for="condition in conditions.$each.$iter"
        :key="condition.condition.id.$model + ficheIndex"
      >
        <template
          v-if="
            condition.emmy.$model.type === 'LIST' ||
              condition.emmy.$model.type === 'CLIMATIC_ZONE'
          "
        >
          <label
              class="input-field_label"
              v-b-tooltip ="{ customClass: 'custom-tooltip' }"
              :title="condition.emmy.$model.name"
              :for="condition"
          >
            <span class="label-text">
              {{ condition.emmy.$model.name }}
            </span>
            <span class="text-danger">*</span>
          </label>
          <div class="input-field_area">
            <select
              :id="'condition-emmy-' + condition.condition.id.$model"
              :disabled="isVIEWER"
              v-model="condition.emmy.$model.value"
              @change="checkConditions()"
              class="small-input"
            >
              <option
                v-for="option of condition.emmy.$model.listConditions"
                :key="option.value"
                :value="option.value"
              >
                {{ option.libelle }}
              </option>
            </select>
            <div
              class="validation-field-holder"
              v-if="
                condition.emmy.value.$anyDirty && condition.emmy.value.$invalid
              "
            >
              <small v-if="!condition.emmy.value.required">
                {{ $t("required_field") }}
              </small>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div v-if="!this.conditions.$invalid && calculFormula" class="giga-fields">
      <div
        class="col-lg-12"
        v-for="item in calculFormula.items.$each.$iter"
        :key="item.id.$model + ficheIndex"
      >
        <div
          v-for="ficheCalculItem in item.ficheCalculItemFicheEmmies.$each.$iter"
          :key="ficheCalculItem.id.$model + ficheIndex"
        >
          <fiche-variable
            :variable="ficheCalculItem.ficheEmmy"
            :isVIEWER="isVIEWER"
            :climateZone="climateZone"
            :ficheIndex="ficheIndex"
          >
          </fiche-variable>
        </div>
      </div>
      <div v-if="userInfo.clientType === 'B2B'">
        <div
          v-for="ficheCalculItem in calculFormula.ficheEmmies.$each.$iter"
          :key="ficheCalculItem.id.$model + ficheIndex"
        >
          <fiche-variable
            :variable="ficheCalculItem"
            :isVIEWER="isVIEWER"
            :climateZone="climateZone"
            :ficheIndex="ficheIndex"
          >
          </fiche-variable>
        </div>
      </div>
      <!--      <b-col cols="12" md="6">
        <b-button  @click="prepareCalculationObject()" :disabled="this.calculFormula.$invalid"
                   pill variant="primary" class="py-2 px-5">
          <span> Test</span>
        </b-button>
      </b-col>
      {{calculation}}-->
    </div>
  </div>
</template>

<script>
import FicheVariable from "./FicheVariable";
import { mapGetters } from "vuex";
export default {
  name: "FicheConditions",
  components: { FicheVariable },
  props: [
    "conditions",
    "calculFormula",
    "ficheIndex",
    "climateZone",
    "isVIEWER"
  ],
  data() {
    return {
      calculation: {
        items: []
      }
    };
  },
  methods: {
    checkConditions() {
      if (!this.conditions.$invalid) {
        this.$emit("checkConditions");
      }
    }
  },
  computed: {
    ...mapGetters("account", { userInfo: "getCurrentUser" })
  }
};
</script>

<style scoped lang="scss">
.input-field_label {
  display: flex;
  gap: 4px;
  .label-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
  }

  .text-danger {
    flex-shrink: 0;
  }
}
</style>


